import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-functions-counter',
  slug: 'counter',
  title: 'A counter nobody else can touch',
  type: 'code',
  estSeconds: 360,
  contentVersion: 1,
});
